import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
const SvgServiceSiteFilter = (props, ref) => /* @__PURE__ */ jsx("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props, children: /* @__PURE__ */ jsx("g", { id: "Icons/Customer_24dp", children: /* @__PURE__ */ jsxs("g", { id: "Union", children: [
  /* @__PURE__ */ jsx("path", { d: "M9 15H6V17H9V15Z", fill: "#999999" }),
  /* @__PURE__ */ jsx("path", { d: "M11 15H14V17H11V15Z", fill: "#999999" }),
  /* @__PURE__ */ jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22 3H16V11H15V7L9.66667 11H9V7.2338L2 11.4338V21H22V3ZM18 5H20V19H18V5ZM16 13H13V11L10.3333 13H7V10.7662L4 12.5662V19H16V13Z", fill: "#999999" })
] }) }) });
const ForwardRef = forwardRef(SvgServiceSiteFilter);
export { ForwardRef as ReactComponent };
